import fulfillmentPlans from "./fulfillmentPlans.component";
import fulfillmentPlansUrls from "./fulfillmentPlans.urls";
import FulfillmentPlansTransforms from "./fulfillmentPlans.transforms";

const fulfillmentPlansModule = angular
  .module("app.components.fulfillmentPlans", [])
  .component("fulfillmentPlansPage", fulfillmentPlans)
  .service("FulfillmentPlansTransforms", FulfillmentPlansTransforms)
  .config(fulfillmentPlansUrls);

export default fulfillmentPlansModule;



// WEBPACK FOOTER //
// ./src/pages/fulfillmentPlans/fulfillmentPlans.module.js